export { default } from "./DialogActions.mjs";
export { default as dialogActionsClasses } from "./dialogActionsClasses.mjs";
export * from "./dialogActionsClasses.mjs";